var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8753 5.51648C12.7888 5.36001 12.662 5.22958 12.5081 5.13875C12.3541 5.04791 12.1787 5 11.9999 5C11.8211 5 11.6457 5.04791 11.4917 5.13875C11.3378 5.22958 11.211 5.36001 11.1246 5.51648L4.62456 17.5165C4.54051 17.6687 4.49761 17.8403 4.5001 18.0141C4.50259 18.188 4.55039 18.3583 4.63877 18.508C4.72716 18.6578 4.85307 18.7819 5.00409 18.8682C5.1551 18.9544 5.32599 18.9998 5.4999 18.9998H18.4999C18.6738 18.9998 18.8447 18.9544 18.9957 18.8682C19.1467 18.7819 19.2727 18.6578 19.3611 18.508C19.4494 18.3583 19.4972 18.188 19.4997 18.0141C19.5022 17.8403 19.4593 17.6687 19.3753 17.5165L12.8753 5.51648Z",
    stroke: "#E7A325",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14V9.5",
    stroke: "#E7A325",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C11.8619 16.5 11.75 16.3881 11.75 16.25C11.75 16.1119 11.8619 16 12 16",
    stroke: "#E7A325"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C12.1381 16.5 12.25 16.3881 12.25 16.25C12.25 16.1119 12.1381 16 12 16",
    stroke: "#E7A325"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4e34e8e3b9342f991bb5118b4bf517c9.svg";
export { ForwardRef as ReactComponent };